module.exports = __webpack_public_path__ + "img/mobile-screen.2b49df0b.svg";